export const FETCH_DISCOUNTS_DATA = "FETCH_DISCOUNTS_DATA";
export const FETCH_DISCOUNTS_SUCCESS = "FETCH_DISCOUNTS_SUCCESS";
export const FETCH_DISCOUNTS_FAILURE = "FETCH_DISCOUNTS_FAILURE";

export const FETCH_DISCOUNTS_EDIT_DATA = "FETCH_DISCOUNTS_EDIT_DATA";
export const FETCH_DISCOUNTS_EDIT_SUCCESS = "FETCH_DISCOUNTS_EDIT_SUCCESS";
export const FETCH_DISCOUNTS_EDIT_FAILURE = "FETCH_DISCOUNTS_EDIT_FAILURE";